import { render, staticRenderFns } from "./xmxunjbaojzdgys2.vue?vue&type=template&id=19b93ad6"
import script from "./xmxunjbaojzdgys2.vue?vue&type=script&lang=js"
export * from "./xmxunjbaojzdgys2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports